import styled from 'styled-components';

export const HealthcareDisparityWrapper = styled.div`
 display: flex;
`;
